'use strict';
const angular = require('angular');

export class documentTreeNodeEditComponent {
  constructor($scope) {
    'ngInject';

    this.node = {id: "", name: "", children: []};
  }

  $onInit () {
    this.config = this.resolve.config;
    this.node = angular.copy(this.config.node);
  };

  updateId() {
    this.node.id = this.slugify(this.node.name);
  }

  slugify(input) {
    // make lower case and trim
    var slug = input.toLowerCase().trim();

    // replace invalid chars with spaces
    slug = slug.replace(/[^a-z0-9&\s-]/g, ' ');

    // replace multiple spaces or hyphens with a single hyphen
    slug = slug.replace(/[\s-]+/g, '-');

    // replace "-&-" with "&"
    slug = slug.replace("-&-", '&');

    return slug;
  }

  ok() {
    this.close({$value: this.node});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }


}

export default angular.module('conduApp.documentTreeNodeEdit', [])
  .component('documentTreeNodeEdit', {
    template: require('./document-tree-node-edit.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: documentTreeNodeEditComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/document-tree-node-edit/document-tree-node-edit.component.js